import { render, staticRenderFns } from "./UsersContainer.vue?vue&type=template&id=1dd60c54&"
import script from "./UsersContainer.vue?vue&type=script&lang=js&"
export * from "./UsersContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports